import React from "react";
import HeroSlider from "../components/HeroSlider";
import PlansSection from "../components/PlansSection";
import { SubscribeSection, CtaSection, OttMarquee, FeatureStrip, CoverageAreasSection } from "../components/Sections";

const Home = () => {
  return (
    <>
      <HeroSlider />
      <PlansSection />
      <CoverageAreasSection />
      <SubscribeSection />
      <CtaSection />
      <OttMarquee />
      <FeatureStrip />
    </>
  );
};

export default Home;
